import React from "react";

import { CommuteMode } from "./CommuteMode";

import * as styles from "../styles";

export const Commute = () => (
  <div className={styles.graphLayoutWrapper}>
    <div className={styles.graphContainer} data-size={"half"}>
      <CommuteMode />
    </div>
  </div>
);
